import { updateIframeHeight } from "../helper"

function Fruchtgummi() {
	return (
		<div className="relative pb-20 mt-20 sm:pb-40 sm:mt-40 bg-white">
			<img
				src={process.env.PUBLIC_URL + "/images/fruchtgummi.png"}
				className=" w-[50%] lg:w-full max-w-md absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 mx-auto z-10  "
				alt=""
				onLoad={() => updateIframeHeight("fruchtgummi")}
			/>
		</div>
	)
}

export default Fruchtgummi
